module.exports = __webpack_public_path__ + "static/media/3H.ce6a76fc.svg";